"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userLogin = exports.urlFormEncode = exports.getToken = exports.getAuthorization = exports.OKTA_TOKEN_URL = exports.OKTA_STATE_PARAM = exports.OKTA_REDIRECT_URI = exports.OKTA_LOGIN_URL = exports.OKTA_CODE_VERIFIER = exports.OKTA_CODE_CHALLENGE = exports.OKTA_CLIENT_ID = exports.OKTA_BASE_URL = exports.OKTA_AUTHORIZE_URL = void 0;
var _environment = _interopRequireDefault(require("../../environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//OKTA REST end point
var OKTA_BASE_URL = exports.OKTA_BASE_URL = _environment.default.OKTA.baseUrl;
var OKTA_LOGIN_URL = exports.OKTA_LOGIN_URL = OKTA_BASE_URL + '/api/v1/authn';
var OKTA_AUTHORIZE_URL = exports.OKTA_AUTHORIZE_URL = OKTA_BASE_URL + '/oauth2/v1/authorize?';
var OKTA_TOKEN_URL = exports.OKTA_TOKEN_URL = OKTA_BASE_URL + '/oauth2/v1/token';

//Okta Application info
var OKTA_CLIENT_ID = exports.OKTA_CLIENT_ID = _environment.default.OKTA.clientId;
var OKTA_REDIRECT_URI = exports.OKTA_REDIRECT_URI = _environment.default.OKTA.redirectUri;

//for PKCE
var OKTA_CODE_VERIFIER = exports.OKTA_CODE_VERIFIER = _environment.default.OKTA.codeVerifier;
var OKTA_CODE_CHALLENGE = exports.OKTA_CODE_CHALLENGE = _environment.default.OKTA.codeChallenge;
var OKTA_STATE_PARAM = exports.OKTA_STATE_PARAM = _environment.default.OKTA.stateParam;
var userLogin = exports.userLogin = function userLogin(username, password) {
  var config = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache'
    },
    body: JSON.stringify({
      username: username,
      password: password
    })
  };
  return fetch(OKTA_LOGIN_URL, config).then(function (response) {
    //console.log('Login Response - ' + username);
    //console.log(response);
    if (response.ok) {
      //console.log(response.headers);
      return response.json();
    } else {
      throw Error(response.json());
    }
  });
};
var urlFormEncode = exports.urlFormEncode = function urlFormEncode(object) {
  var pairs = [];
  for (var key in object) {
    var val = object[key];
    if (val !== undefined) {
      pairs.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(val)));
    }
  }
  return pairs.join('&');
};
var getAuthorization = exports.getAuthorization = function getAuthorization(sessionToken) {
  var params = urlFormEncode({
    client_id: OKTA_CLIENT_ID,
    redirect_uri: OKTA_REDIRECT_URI,
    response_type: 'code',
    response_mode: 'form_post',
    state: OKTA_STATE_PARAM,
    sessionToken: sessionToken,
    scope: 'openid',
    code_challenge_method: 'S256',
    code_challenge: OKTA_CODE_CHALLENGE
  });
  //console.log(`authorization params: ${JSON.stringify(params)}`);
  var sid = '';
  return fetch(OKTA_AUTHORIZE_URL + params, {
    redirect: 'error'
  }).then(function (response) {
    //console.log(response.headers);
    var cookies = response.headers.get('Set-Cookie');
    var sidCookie = cookies.split('sid=');
    if (sidCookie !== null && sidCookie.length === 2) {
      var sidParts = sidCookie[1].split(';');
      if (sidParts !== null && sidParts.length >= 1) {
        sid = sidParts[0];
      }
    }
    if (response.status === 200) {
      return response.text();
    }
  }).then(function (body) {
    // finds the input with type hidden and name code
    var INPUT_CODE_REGEX = /<input[^>]*\s*(?=[^>]*type\s*=\s*('|"|)hidden\s*(\1))[^>]*\s*(?:name\s*=('|"|)code\s*(\3))[^>]*/i;
    //console.log('sid: ' + sid);
    var code = body.match(INPUT_CODE_REGEX);
    return {
      sid: sid,
      authCode: code[0].substring(code[0].indexOf('value=') + 7, code[0].length - 2)
    };
  }).catch(function (error) {});
};
var getToken = exports.getToken = function getToken(authCode) {
  var options = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
      'Cache-Control': 'no-cache'
    },
    body: urlFormEncode({
      grant_type: 'authorization_code',
      client_id: OKTA_CLIENT_ID,
      redirect_uri: OKTA_REDIRECT_URI,
      code: authCode,
      code_verifier: OKTA_CODE_VERIFIER
    })
  };

  //clear cookie also
  //console.log(`getToken: ${JSON.stringify(options)}`);
  return fetch(OKTA_TOKEN_URL, options).then(function (response) {
    //console.log(`getToken: ${JSON.stringify(response)}`);
    if (response.status === 200 || response.status === 400) {
      var responseJson = response.json();
      return responseJson;
    }
    if (response.status === 403) {
      throw Error(response.text());
    }
  });
};

/* export const forgotPassword = emailAddress => {
  const fullUrl = RESET_PW_URL + '/' + encodeURIComponent(emailAddress);
  const config = Object.assign({}, CONFIG);
  return fetch(fullUrl, config)
    .then(result => result.json())
    .catch(err => {
      return { error: { code: 1, message: err.message } };
    });
}; */